@if (isLoader) {
  <div>
    <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Facebook'"></app-sidebar-header>
    <div class="inst-loader-container">
      <app-loader size="big"></app-loader>
    </div>
  </div>
} @else {
  <div class="h-100 overflow-auto crm-scroll inst-integration-container">
    <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Facebook'"></app-sidebar-header>
    <mat-card class="shadow-none bg-transparent">
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <div class="header-container">
          <div class="icon-logo">
            <img src="/assets/svgs/integrations/facebook.svg" alt="Facebook logo" />
          </div>
          <h5 class="inst-integration-description">{{ 'log_in_with_your_facebook_account' | translate }}</h5>
        </div>
        <div class="pt-3">
          <p>{{ 'channel' | translate }}: {{ channel_name }}</p>
          <p>
            {{ 'status' | translate }}:
            @if (CHANNEL_STATUS_OBJECT[status]) {
              <span class="badge" [ngStyle]="{ 'background-color': CHANNEL_STATUS_OBJECT[status].color }">
                {{ 'channel_status_new.' + CHANNEL_STATUS_OBJECT[status].textKey | translate }}
              </span>
            }
          </p>
          <div class="d-flex gap-2 flex-wrap justify-content-center">
            @switch (status) {
              @case (CHANNEL_STATUS.CONNECTED) {
                <app-button btnType="stroked" (onChangeClick)="deleteChannel()">{{ 'delete' | translate }}</app-button>
              }
              @default {
                <app-button (onChangeClick)="connectAccount()">{{ 'connect' | translate }}</app-button>
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    @if (showQr) {
      <mat-card class="shadow-none bg-transparent">
        <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
          <div class="qr-code-container">
            <p class="qr-code-description">{{ 'scan_qr_for_facebook' | translate }}</p>
            <div #qrcode></div>
            <div class="d-flex gap-2 flex-wrap justify-content-center">
              <app-button (onChangeClick)="copyConnectUrlToClipboard()"
                >{{ 'copy_to_clipboard' | translate }}
              </app-button>
              <app-button (onChangeClick)="openWindow()">{{ 'open_link' | translate }}</app-button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (facebookPages.length) {
      <mat-card class="shadow-none bg-transparent">
        <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4 gap-3">
          <p class="facebook-page-list-title">{{ 'choose_facebook_page' | translate }}</p>
          <div class="facebook-page-list">
            @for (page of facebookPages; track page.id) {
              <button
                type="button"
                class="facebook-page-item"
                [class.disabled]="page.disabled"
                [class.selected]="isSelectedPage(page)"
                [disabled]="page.disabled"
                (click)="selectPage(page)"
              >
                @if (page.picture_url) {
                  <img [src]="page.picture_url" alt="" />
                }
                <div class="facebook-page-meta">
                  <span class="facebook-page-name">{{ page.name }}</span>
                  @if (page.category) {
                    <span class="facebook-page-category">{{ page.category }}</span>
                  }
                  @if (page.disabled) {
                    <span class="facebook-page-status">
                      {{ 'facebook_page_already_connected' | translate }}
                      @if (page.connected_channel_name) {
                        : {{ page.connected_channel_name }}
                      }
                    </span>
                  }
                </div>
              </button>
            }
          </div>
          <div class="d-flex gap-2 flex-wrap justify-content-center">
            <app-button [disabled]="selectedPageControl.invalid" (onChangeClick)="selectFacebookPage()">
              {{ 'connect' | translate }}
            </app-button>
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (username) {
      <div>
        <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
          <h5>{{ 'information' | translate }}</h5>
          <mat-divider class="mb-3"></mat-divider>
          <p class="text-secondary">
            {{ 'username' | translate }}: <span class="text-dark">{{ username }}</span>
          </p>
          @if (name) {
            <p class="text-secondary">
              {{ 'name' | translate }}: <span class="text-dark">{{ name }}</span>
            </p>
          }
        </mat-card-content>
      </div>
    }
    <app-integration-review
      [youtubeReviewLink]="'https://www.youtube.com/watch?v=EkbSMdgLTvw'"
    ></app-integration-review>
  </div>
}
